import React from "react";
import { getRecoil, setRecoil } from "recoil-nexus";
import io from "socket.io-client";
import ApiController from "../../controller/ApiController";
import MessageController from "../../controller/MessageController";
import { authState, authStoreType, currentStoreState } from "../../recoil/auth";
import {
  chatFinishedState,
  chatState,
  newChatListState,
} from "../../recoil/chat";
import {
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
} from "../../recoil/type";
import taskQueue from "../../utils/TaskQueue";
import {
  completeOrderState,
  connectState,
  loginState,
  newOrderState,
  notCompleteOrderState,
  refreshAppState,
  updateBarogoState,
} from "./socketState";

let socket: any;

const SocketService = React.memo(() => {
  const processMsg = async (oParsed: {
    user_token_id: number;
    action: string;
    url: string;
    params: any;
    send_log_id: number;
  }) => {
    try {
      console.log("enqueue", JSON.stringify(oParsed));
      console.log("oParsed", oParsed, oParsed.action, oParsed.params);
      if (oParsed && oParsed.action && oParsed.action === "newOrder") {
        setRecoil(newOrderState, {
          date: new Date().getTime().toString(),
          is_update: false,
          order_id: oParsed.params.order_id,
        });
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "changeOrder"
      ) {
        if (
          oParsed.params.order_status === ORDER_COM_STATUS ||
          oParsed.params.order_status === ORDER_COM_DEL_STATUS ||
          oParsed.params.order_status === ORDER_CANCLE_STATUS
        ) {
          console.log("~~~~~~~~~~~~~~~~~~~~changeOrder com~~~~~~~~~~~~~~~~~~");
          setRecoil(completeOrderState, {
            date: new Date().getTime().toString(),
            order_status: oParsed.params.order_status,
            is_update: false,
          });
        } else {
          console.log(
            "~~~~~~~~~~~~~~~~~~~~changeOrder notCom~~~~~~~~~~~~~~~~~~",
            oParsed
          );
          setRecoil(notCompleteOrderState, {
            date: new Date().getTime().toString(),
            order_status: oParsed.params.order_status,
            order_id: oParsed.params.order_id,
            user_token_id: oParsed.params.user_token_id,
            is_update: false,
            is_print: false,
          });
        }
        // SoundControl.playSoundOnce();
      } else if (
        oParsed &&
        oParsed.action &&
        oParsed.action === "barogoDeliveryUpdate"
      ) {
        console.log(
          "~~~~~~~~~~~~~~~~~~~~barogoDeliveryUpdate~~~~~~~~~~~~~~~~~~"
        );
        setRecoil(updateBarogoState, {
          date: new Date().getTime().toString(),
          is_update: false,
        });
      } else if (oParsed.action === "bypass") {
        console.log("~~~~~~~~~~~~~~~~~~~~throo~~~~~~~~~~~~~~~~~~");
        setRecoil(completeOrderState, {
          date: new Date().getTime().toString(),
          is_update: false,
          order_status: 0,
        });
      } else if (oParsed.action === "pause") {
        console.log("~~~~~~~~~~~~~~~~~~~~pause~~~~~~~~~~~~~~~~~~");

        const auth = getRecoil(authState);
        const res = await ApiController.auth.getStoreList(auth.user_id);
        if (res.data.data) {
          const filteredStore = res.data.data.find(
            (item: authStoreType) =>
              item.store_id === getRecoil(currentStoreState).value?.store_id
          );
          if (filteredStore) {
            setRecoil(currentStoreState, {
              ...getRecoil(currentStoreState),
              value: filteredStore,
            });
          }
        }

        // setRecoil(authState, {...auth,pause:oParsed.params.pause});
      } else if (oParsed.action === "refresh") {
        console.log("~~~~~~~~~~~~~~~~~~~~refresh~~~~~~~~~~~~~~~~~~");
        setRecoil(refreshAppState, true);
      } else if (oParsed.action === "DIRECT_MESSAGE") {
        console.log("~~~~~~~~~~~~~~~~~~~~DIRECT_MESSAGE~~~~~~~~~~~~~~~~~~");
        setRecoil(chatState, (prev) => ({
          ...prev,
          cs_id: oParsed.params.cs_id,
          date: new Date().toString(),
        }));
        console.log("oParsed.params.status", oParsed.params.status);
        if (oParsed.params.status && oParsed.params.status === "FINISHED") {
          console.log("~~~~~~~~~~DIRECT_MESSAGE FINISHED~~~~~~~~~~~~~");
          setRecoil(chatFinishedState, true);
        } else {
          if (
            getRecoil(newChatListState).findIndex(
              (item) =>
                item.order_id === oParsed.params.order_id &&
                item.order_seq === oParsed.params.order_seq &&
                item.store_id === oParsed.params.store_id
            ) === -1
          ) {
            setRecoil(newChatListState, [
              ...getRecoil(newChatListState),
              {
                cs_id: oParsed.params.cs_id,
                store_id: oParsed.params.store_id,
                order_id: oParsed.params.order_id,
                order_seq: oParsed.params.order_seq,
              },
            ]);
          }
        }
      }
    } catch (err) {
      console.log("!!!!!processMsg error:", err);
      return;
    }
  };

  // const [sReceivedMsg, set_sReceivedMsg] = React.useState<any>('');

  const startSocket = async () => {
    console.log("start!!!!");
    // let token = await AppConfigController.getObjectCryptoAsyncStorage('refresh-token');
    // let token = nowAuth.refreshToken;
    // let token = await RecoilAsyncStorage.getItem('refresh-token');
    console.log(
      "process.env.REACT_APP_WEBSOCKET_URL",
      process.env.REACT_APP_WEBSOCKET_URL
    );
    if (socket && socket.connected === true) {
      return;
    }

    //auth: { token: token },

    // console.log('Config.WEBSOCKET_URL', Config.WEBSOCKET_URL);

    socket.connect();

    socket.on("connect", () => {
      console.log("connected --------------- socket ---------------");
      setRecoil(connectState, { type: true, is_first: false });
    });

    socket.on("connect_error", (err: any) => {
      console.log(err.message);
      setRecoil(connectState, { type: false, is_first: false });
    });

    socket.on("disconnect", () => {
      console.log("Disconnected from server");
      setRecoil(connectState, { type: false, is_first: false });
    });

    socket.on("msg", async (msg: any) => {
      console.log("queue??");
      window.ReactNativeWebView?.postMessage(
        MessageController.getEchoData({ msg: JSON.stringify(msg) })
      );

      if (msg) {
        try {
          let oParsed = JSON.parse(msg);
          taskQueue.enqueueTask(async () => {
            await processMsg(oParsed);
            socket.emit("confirm", "OK");
          });
        } catch (err) {
          console.log(err);
          console.log(msg);
        }
      }
    });
  };

  const checkSocketState = (event: any) => {
    if (event && event.data) {
      let oMsg;
      try {
        // console.log("orderlinkweb > Home.tsx oMsg.action", event);
        oMsg = JSON.parse(event.data);
      } catch (error) {}
      if (oMsg) {
        if (socket) {
          if (
            oMsg.action &&
            oMsg.action === "refresh_state" &&
            socket.connected
          ) {
            console.log("socket check success");
          } else {
            startSocket();
            // LogController.event({
            //   path: "Socket",
            //   params: "소켓 재접속",
            //   params2: "",
            // });
          }
        }
      }
    }
  };

  React.useEffect(() => {
    document.addEventListener("message", checkSocketState);
    window.addEventListener("message", checkSocketState);

    return () => {
      document.removeEventListener("message", checkSocketState);
      window.removeEventListener("message", checkSocketState);
    };
  }, []);

  React.useEffect(() => {
    if (loginState) {
      setTimeout(() => {
        let oAuthData: any = getRecoil(authState);
        socket = io(`${process.env.REACT_APP_WEBSOCKET_URL}`, {
          secure: true,
          transports: ["websocket", "polling"],
          autoConnect: false,
          auth: { token: oAuthData.refresh_token },
          reconnection: true,
          reconnectionDelay: 500,
          rejectUnauthorized: false,
        });
        if (oAuthData && oAuthData.refresh_token) {
          startSocket();
        }
      }, 1000);
    }
  }, [loginState]);

  return <></>;
});

export default SocketService;
